import React, { useState, useEffect } from 'react';
import { Area, AreaStatus } from '../app/types';
import axios from 'axios';
import { urlAreas } from '../app/EndPoints';
import { GetAreaDTO } from '../models/AreaDTO';


interface AreaFormPageProps {
  areaToEdit: GetAreaDTO | null;
  idMembership: number;
  onSave: (area: GetAreaDTO) => void;
  onCancel: () => void;
  onRefresh: () => void;
}

const AreaFormPage: React.FC<AreaFormPageProps> = ({ areaToEdit, idMembership, onSave, onCancel, onRefresh }) => {
  const [name, setName] = useState('');
  const [id, setId] = useState(0);
  const [status, setStatus] = useState<AreaStatus>(areaToEdit?.Enabled === 1 ? AreaStatus.ACTIVO : AreaStatus.INACTIVO);
  const [error, setError] = useState('');

  useEffect(() => {
    if (areaToEdit) {
      setName(areaToEdit.Name);      
      setId(areaToEdit.Id)
    } else {
      setName('');
      setStatus(AreaStatus.ACTIVO);
    }
  }, [areaToEdit]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('El nombre del área es obligatorio.');
      return;
    }

    let jsonData 
    if (areaToEdit) {
      //EDITAR      
      jsonData = {
        "id" : id,
        "name" : name.trim().toUpperCase(),
        "enabled" : status === "Activo" ? 1 : 0
      }      
      await axios.patch(urlAreas, jsonData)
      .then((respuesta) => {       
        onSave({
          Id: areaToEdit?.Id || 0,
          Name: name.trim().toUpperCase(),
          Enabled: status === "Activo" ? 1 : 0,
        });     
        onCancel()
      })
      .catch((error) => {            
        setError(error)
          console.log(error);
      });  
    }else{
      //CREAR
      jsonData = {
        "membership" : idMembership,
        "name" : name.trim().toUpperCase(),
        "enabled" : 1
      }      
      await axios.post(urlAreas, jsonData)
        .then((respuesta) => {                      
          onRefresh()
          onCancel()
        })
        .catch((error) => {            
          setError(error)
            console.log(error);
        });    
    }          
  };

  return (
    <div className="bg-surface dark:bg-dark-surface p-6 rounded-3xl shadow-sm max-w-2xl mx-auto">
      <div className="mb-6" style={{textAlign:"left"}}>
        <h2 className="text-2xl font-medium text-on-surface dark:text-dark-on-surface">
          {areaToEdit ? 'Editar Área' : 'Crear Nueva Área'}
        </h2>
        <p className="text-on-surface-variant dark:text-dark-on-surface-variant mt-1">
          Completa los detalles del área a continuación.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6"  style={{textAlign:"left"}}>
        <div>
          <label htmlFor="area-name" className="block text-sm font-medium text-on-surface-variant dark:text-dark-on-surface-variant mb-2">
            Nombre del Área
          </label>
          <input
            id="area-name"
            type="text"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              if (error) setError('');
            }}
            required
            className="w-full bg-surface-container dark:bg-dark-surface-container border-2 border-outline dark:border-dark-outline focus:border-primary dark:focus:border-dark-primary focus:ring-0 rounded-lg p-3 outline-none transition-colors"
            placeholder="Ej: Desarrollo de Software | CTO | Sede Principal"
          />
          {error && <p className="text-error dark:text-dark-error text-sm mt-2">{error}</p>}
        </div>

        <div>
          <label htmlFor="area-status" className="block text-sm font-medium text-on-surface-variant dark:text-dark-on-surface-variant mb-2">
            Estado
          </label>
          <select
            id="area-status"
            value={status}
            onChange={(e) => setStatus(e.target.value as AreaStatus)}
            className="w-full bg-surface-container dark:bg-dark-surface-container border-2 border-outline dark:border-dark-outline focus:border-primary dark:focus:border-dark-primary focus:ring-0 rounded-lg p-3 outline-none transition-colors appearance-none"
          >
            <option value={AreaStatus.ACTIVO}>Activo</option>
            <option value={AreaStatus.INACTIVO}>Inactivo</option>
          </select>
        </div>

        {error && <p className="text-error dark:text-dark-error text-sm mt-2">{error}</p>}

        <div className="flex justify-end gap-4 pt-4">
          <button
            type="button"
            onClick={onCancel}
            className="px-6 py-2.5 rounded-full text-primary dark:text-dark-primary font-bold hover:bg-primary/10 dark:hover:bg-dark-primary/10 transition-colors"
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="px-6 py-2.5 rounded-full bg-primary dark:bg-dark-primary text-on-primary dark:text-dark-on-primary font-bold hover:shadow-lg transition-shadow"
          >
            Guardar
          </button>
        </div>
      </form>
    </div>
  );
};

export default AreaFormPage;
